export const comment = {
  WASTE: 'Waste',
  ABUSE: 'Abuse',
  FRAUD: 'Fraud',
  ACCEPTABLE: 'Acceptable',
  PROVEN: 'Proven',
  SUSPICIOUS: 'Suspicious',
  NOTPROVEN: 'NotProven',
  PREEXISTINGDAMAGE: 'PreExistingDamage',
  POSTACCIDENTINSURANCE: 'PostAccidentInsurance',
  INFLATEDCHARGES: 'InflatedCharges',
  LIABILITYDISPUTE: 'LiabilityDispute',
  SHAREDRESPONSIBILITY: 'SharedResponsibility',
};
